import styled from 'styled-components';
import Card from './ui/Card';
import { exportCanvasPng } from '../helpers/exportCanvas';

export type CanvasPreviewProps = {
	open: boolean;
	onClose: () => void;
};

/** Shows the artwork at its real pixel size, as it will be saved. */
function CanvasPreview({ open, onClose }: CanvasPreviewProps) {
	let preview = '';
	try {
		preview = open ? exportCanvasPng() : '';
	} catch (error) {
		console.error(error);
	}

	return (
		<Card open={open} title="Preview" onClose={onClose} description="Your artwork at its actual size.">
			<Frame>{preview ? <img src={preview} alt="Artwork preview" /> : <span>Sorry, the preview is not available right now.</span>}</Frame>
		</Card>
	);
}

export default CanvasPreview;

const Frame = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	padding: 16px;
	background-color: #000;
	border-radius: 10px;
	overflow: auto;

	img {
		image-rendering: pixelated;
	}
`;
